import type { IconData } from '@stacksjs/iconify-core'

export const webSectionAlt: IconData = {
  "body": "<path fill=\"currentColor\" d=\"M9.9 2H8.1A2.6 2.6 0 0 0 8 3v18c-.032.337.002.676.1 1h1.8c.098-.324.132-.663.1-1V3a2.6 2.6 0 0 0-.1-1\" opacity=\".25\"/><path fill=\"currentColor\" d=\"M3 2h5v20H3a1 1 0 0 1-1-1V3a1 1 0 0 1 1-1\"/><path fill=\"currentColor\" d=\"M10 2h11a1 1 0 0 1 1 1v18a1 1 0 0 1-1 1H10z\" opacity=\".5\"/>",
  "width": 24,
  "height": 24,
  "viewBox": "0 0 24 24"
}

export default webSectionAlt
